import { axiosInstance } from '../services/axiosInstance';
import catchAsync from '../utils/catchAsync';

export const addPurchaseInvoice = catchAsync(async (body) => {
  const { data } = await axiosInstance.post(
    '/api/resource/Purchase Invoice',
    body
  );
  return data;
});
export const updatePurchaseInvoice = catchAsync(async (body, id) => {
  const { data } = await axiosInstance.put(
    `/api/resource/Purchase Invoice/${id}`,
    body
  );
  return data;
});

export const getPurchaseInvoice = catchAsync(
  async ({ key = '', value = '' }) => {
    let baseUrl =
      '/api/resource/Purchase Invoice?fields=["name","supplier_name","posting_date","grand_total","status","docstatus","rounded_total", "outstanding_amount"]&order_by=name desc&filters=[["is_return","=", "0"]]&limit_start=0&limit_page_length=0';
    if (value) {
      if (key === 'posting_date') {
        baseUrl += `&filters=[["posting_date","Between",["${value}","${value}"]]]`;
      } else {
        baseUrl += `&filters=[["${key}","like","%${value}%"]]`;
      }
    }
    const { data } = await axiosInstance.get(baseUrl);
    return data;
  }
);

export const getDebitNoteList = catchAsync(async ({ key = '', value = '' }) => {
  let baseUrl =
    '/api/resource/Purchase Invoice?fields=["name","grand_total","supplier_name","posting_date","status","rounded_total"]&order_by=name desc&filters=[["is_return","=", "1"]]&limit_start=0&limit_page_length=0';
  if (value) {
    if (key === 'posting_date') {
      baseUrl += `&filters=[["posting_date","Between",["${value}","${value}"]]]`;
    } else {
      baseUrl += `&filters=[["${key}","like","%${value}%"]]`;
    }
  }
  const { data } = await axiosInstance.get(baseUrl);
  return data;
});
export const deletePurchaseInvoice = catchAsync(async (record) => {
  const { data } = await axiosInstance.delete(
    `/api/resource/Purchase Invoice/${record}`
  );
  return data;
});
export const getPurchaseInvoiceDetails = catchAsync(async (id) => {
  const { data } = await axiosInstance.get(
    `/api/resource/Purchase Invoice/${id}`
  );
  return data;
});
export const getMapReferenceRecieptAndInvoice = catchAsync(async (id) => {
  const { data } = await axiosInstance.get(
    `/api/method/technoerp.services.map_reference?target=PR PI&source=${id}`
  );
  return data;
});
export const getMapReferenceMakePR = catchAsync(async (id) => {
  const { data } = await axiosInstance.get(
    `/api/method/technoerp.services.map_reference?target=Make PR&source=${id}`
  );
  return data;
});
export const getDebitNote = catchAsync(async (id) => {
  const { data } = await axiosInstance.get(
    `/api/method/technoerp.services.map_reference?target=PI DN&source=${id}`
  );
  return data;
});
export const getPartyDetails = catchAsync(async (id) => {
  const { data } = await axiosInstance.get(
    `/api/method/technoerp.services.get_party_details?party_type=Supplier&party=${id}&type=Purchase Invoice`
  );
  return data;
});
